// @ts-expect-error TS(7016) - No types for url-regex-safe
import urlRegex from 'url-regex-safe';

export const TWITTER_MAX_LENGTH = 280;

export function currentTwitterMessageLength(message: string) {
  // urlRegex comes from app/webpack/javascripts/dashboard/social_media_url_shim.js
  const urls = message.match(urlRegex()) || [];

  // twitter makes all urls 23 characters
  // https://developer.twitter.com/en/docs/counting-characters
  // Same logic is on the BE - lib/social_media/twitter_client.rb
  return message.length + urls.length * 23 - urls.join('').length;
}
